import Swal from "sweetalert2";
import { useGlobalContext } from "../../context/GlobalContext";
import { useToastContext } from "../../context/ToastContext";
import { cancelSubscription } from "../../services/api/packages";
import LoadSpinner from "../LoadingSpinner";
import { CONSTANTS } from "../../constants/Constants";

interface DropdownProps {
  user: any;
  onLogout: () => void;
  dropdownRef: any
}

const ProfileDropdown: React.FC<DropdownProps> = ({ user, onLogout, dropdownRef }) => {
  const { showToast } = useToastContext()
  const { setIsLoading, isLoading } = useGlobalContext()
  const cancelSubscriptionHandler = async () => {
    Swal.fire({
      text: CONSTANTS.UNSUBCRIPTION_CONFIRMATION_TXT + CONSTANTS.YOU_WILL_BE_ALLOWED_TXT,
      toast: true,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: CONSTANTS.CONFIRM_TXT,
      customClass: {
        cancelButton:
          "text-gray-800 bg-gray-300 rounded-full text-sm w-[100px]",
        confirmButton: "rounded-full bg-black text-sm w-[100px]",
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        setIsLoading(true)
        let res = await cancelSubscription(user?.user?.subId)
        showToast(res, "success")
        window.location.reload()
        setIsLoading(false)
      }
    });
  }
  return (
    <div ref={dropdownRef} className="absolute top-16 right-10 mt-2 w-48 bg-white border border-gray-200 rounded-lg shadow-lg z-50">
      {user?.user?.subId && <div className="py-2 px-4 border-b text-gray-800 font-medium cursor-pointer"
        onClick={cancelSubscriptionHandler}
      >
        {isLoading ? <LoadSpinner /> :
          <span>{CONSTANTS.UNSUBCRIBE_TXT}</span>}
      </div>}
      <div
        onClick={onLogout}
        className="w-full text-left py-2 px-4 text-error hover:bg-gray-100 cursor-pointer"
      >
        {CONSTANTS.LOGOUT_TXT}
      </div>
    </div>
  );
};

export default ProfileDropdown;
